<template>
    <div id="BoxReceive" class="row">
        <TabNav :tabs="['Scan', 'Assign Location']" :selected="selected" @selected="setSelected" >
            <Tab :isSelected="selected === 'Scan'">
                    <Scan />
            </Tab>
            <Tab :isSelected="selected === 'Assign Location'">
                    <AssignLocation />
            </Tab>
        </TabNav>
    </div>
</template>

<script>
  import TabNav from '../../../common/TabNav'
  import Tab from '../../../common/Tab'
  import Scan from './Xfer/Scan'
  import AssignLocation from './Xfer/AssignLocation'
  export default {
    name: 'BoxReceive',
    components: {
      TabNav,
      Tab,
      Scan,
      AssignLocation
    },
    mounted() {
      this.isPowerScan = true;
    },
    data() {
      return {
        selected: 'Scan',
        isPowerScan: this.$store.getters['Navigation/isPowerScan'],
      }
    },
    methods: {
      setSelected(tab) {
        this.selected = tab
      }
    }
  }
</script>